import { Icon, type IconProps } from "./icon";

/** Contacts: one reader of the audience. */
export function ContactsIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <circle cx="10" cy="7" r="3" />
      <path d="M4.25 16.5a5.75 5.75 0 0 1 11.5 0" />
    </Icon>
  );
}
